/**
 * Reports & Analytics Tour
 *
 * Walks users through the reporting dashboard, analytics page,
 * and Astor AI analytics.
 */

import type { TourConfig } from './tour-config.types';

export const reportsTour: TourConfig = {
  id: 'reports-analytics-overview',
  title: 'tours.reports.title',
  portal: 'business',
  steps: [
    {
      target: '[data-astor-id="reports-dashboard"]',
      content: 'tours.reports.steps.reports',
      placement: 'bottom',
      route: '/reports',
    },
    {
      target: '[data-astor-id="analytics-dashboard"]',
      content: 'tours.reports.steps.analytics',
      placement: 'bottom',
      route: '/analytics',
    },
    {
      target: '[data-astor-id="astor-analytics"]',
      content: 'tours.reports.steps.astorAnalytics',
      placement: 'bottom',
      route: '/control-center/astor/analytics',
    },
  ],
};
